import { jsonGuard } from '@rivenai/connector-kit';
import { z } from 'zod';
export var RivenAuthInlineHookKey;
(function (RivenAuthInlineHookKey) {
    RivenAuthInlineHookKey["PostFirstFactorVerification"] = "inlineHook.postFirstFactorVerification";
    RivenAuthInlineHookKey["PostSignIn"] = "inlineHook.postSignIn";
})(RivenAuthInlineHookKey || (RivenAuthInlineHookKey = {}));
export const inlineHookExecutionErrorPolicies = Object.freeze(['block', 'allow']);
export const inlineHookGuard = z
    .object({
    script: z.string(),
    environmentVariables: z.record(z.string()).optional(),
    contextSample: jsonGuard.optional(),
    enabled: z.boolean().optional(),
    onExecutionError: z.enum(inlineHookExecutionErrorPolicies).optional(),
})
    .strict();
export const inlineHookTestRequestBodyGuard = z
    .object({
    script: z.string(),
    hookType: z.nativeEnum(RivenAuthInlineHookKey),
    event: jsonGuard,
    environmentVariables: z.record(z.string()).optional(),
})
    .strict();
